<wl-simple-progressive-form-card
  [progressiveFormState]="progressiveFormState"
  [content]="progressiveFormCardContent"
  [trackingConfig]="{
    toolName: rendering.componentName,
    step: stepNumber!,
    stepName: 'slim combineren',
  }"
>
  <ng-template #content>
    <div
      class="cross-sell-card"
      [class.checked]="formState?.value?.hasSelectedProduct"
      (click)="onCardClick($event)"
      (keydown.Space)="onCardClick($event)"
    >
      <div class="cross-sell-card__header">
        <h4 class="h3">{{ product.content.longTitle }}</h4>
        <span>
          <strong>+ {{ product.price | euroCurrency: '1.0-2' }}</strong>
          {{ fields.CrossSellMonthlyShort?.value }}
        </span>
      </div>
      <div class="cross-sell-card__body">
        <p *wlGenericRichText="product.content?.longSubtitle"></p>
      </div>
      <wl-generic-usps [usps]="usps" />
      <div class="cross-sell-card__footer">
        <button
          type="button"
          class="p-0 btn btn-link text-primary"
          (click)="onMoreInfoClick($event)"
          (keydown.Space)="onMoreInfoClick($event)"
        >
          <span>{{ fields.CrossSellInfoModalLink?.value }}</span
          ><fa-icon icon="chevron-right" class="ms-1"></fa-icon>
        </button>
        <div class="form-check form-check-reverse cross-sell-card__check">
          <label class="form-check-label" for="selectProduct">
            {{
              formState?.value?.hasSelectedProduct
                ? fields.CrossSellAddedLabel?.value
                : fields.CrossSellAddLabel?.value
            }}
          </label>
          <input
            id="selectProduct"
            name="selectProduct"
            [ngrxFormControlState]="formState?.controls?.hasSelectedProduct"
            type="checkbox"
            class="form-check-input"
            wlHasValueClass="has-value"
            [ngrxEnableFocusTracking]="true"
            (click)="$event.stopPropagation()"
            (keydown.Space)="$event.stopPropagation()"
          />
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #summary>
    <div class="cross-sell-summary">
      @if (formState?.value?.hasSelectedProduct) {
        <p class="product-title">{{ product.content.longTitle }}</p>
        <p class="product-subtitle">
          <span *wlGenericRichText="product.content.longSubtitle"></span
          ><span>
            (+ {{ product.price | euroCurrency: '1.0-2' }}
            {{ fields.CrossSellMonthlyShort?.value }})</span
          >
        </p>
      } @else {
        <p class="product-title">
          {{ fields.CrossSellNoProductSelectedTitle?.value }}
        </p>
        <p class="product-subtitle">
          {{ fields.CrossSellNoProductSelectedSubtitle?.value }}
        </p>
      }
    </div>
  </ng-template>
</wl-simple-progressive-form-card>
